/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import { List } from '@veneer/core';
import React, { memo } from 'react';
import TStatusListItem, { StatusListItemAnalytics } from './StatusListItem';
import './styles.scss';
import { StatusListProps } from './types';
import { generateID } from '../../base/helper';

/**
 * UI Toolkit : Status List
 * @public
 */
const StatusList: React.FC<StatusListProps> = ({
  statusItemList,
  id = generateID('clientos-ui-toolkit-status-list')
}) => {
  return (
    <List
      className="clientos-ui-toolkit-status-list clientos-ui-toolkit-status-list__container"
      id={id}
    >
      {statusItemList?.map((item, index) => {
        const {
          trackId,
          trackCategory,
          trackedHandlers,
          stopTracking,
          untrackedHandlers,
          canReturnParams,
          ...rest
        } = item;
        if (trackId) {
          return (
            <StatusListItemAnalytics
              key={index}
              trackId={trackId}
              trackCategory={trackCategory}
              trackedHandlers={trackedHandlers}
              untrackedHandlers={untrackedHandlers}
              stopTracking={stopTracking}
              canReturnParams={canReturnParams}
              {...rest}
            />
          );
        }
        return (
          <TStatusListItem
            key={index}
            {...rest}
          />
        );
      })}
    </List>
  );
};

export default memo(StatusList);
